<template>
  <div>
    <confirm-modal name="add-feed-type-modal" title="Add New Feed Type">
      <div class="form-group kt-form__group">
        <label for="new-feed-type-label">Label
          <em>*</em></label>
        <input id="new-feed-type-label" v-model="new_feed_type.label"
               type="text"
               class="form-control kt-input" placeholder="Enter Label">
        <span class="kt-form__help">Text that shows up in the dropdown.</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="new-feed-type-format">Format
          <em>*</em></label>
        <input id="new-feed-type-format" v-model="new_feed_type.format"
               type="text"
               class="form-control kt-input"
               placeholder="Enter Format">
        <span class="kt-form__help">Feed type that exists in feed repository: podcast, simple, etc.</span>
      </div>

      <div class="form-group kt-form__group">
        <label for="new-feed-type-extension">Extension
          <em>*</em></label>
        <input id="new-feed-type-extension" v-model="new_feed_type.extension"
               type="text"
               class="form-control kt-input"
               placeholder="Enter Extension">
        <span class="kt-form__help">Default is xml but you can do
          rss, html and other.</span>
      </div>

      <div class="form-group kt-form__group">
        <ss-checkbox id="feed-type-enabled" v-model="new_feed_type.enabled">
          Enabled
        </ss-checkbox>
      </div>
    </confirm-modal>

    <div class="alert alert-ss-primary fade show" role="alert">
      <div class="alert-icon">
        <i class="flaticon-warning" />
      </div>
      <div class="alert-text">
        Developer Use Only!
      </div>
      <div class="alert-close">
        <button type="button" class="close"
                data-dismiss="alert"
                aria-label="Close">
          <span aria-hidden="true"><i class="la la-close" /></span>
        </button>
      </div>
    </div>

    <!--begin::Portlet-->
    <div id="kt_portlet_tools_1" class="kt-portlet" data-ktportlet="true">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Feed Types
          </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
          <div class="kt-portlet__head-group">
            <a href="#" class="btn btn-ss-standout"
               @click="$modal.show(`add-feed-type-modal`)">Add New Feed Type</a>
          </div>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-portlet__content">
          <table class="table feeds-table">
            <thead class="thead-light">
              <tr>
                <th scope="col">
                  Label
                </th>
                <th scope="col">
                  Format
                </th>
                <th scope="col">
                  Extension
                </th>
                <th scope="col">
                  Enabled
                </th>
                <th scope="col">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(feed_type, index) in feed_types" :key="index">
                <td>
                  {{ feed_type.label }} <span v-if="used_feeds && used_feeds.length">(Used {{ getUsedCount(feed_type.id) }} Times)</span>
                </td>
                <td>{{ feed_type.format }}</td>
                <td>{{ feed_type.extension }}</td>
                <td>
                  <b-form-checkbox v-model="feed_type.enabled" name="enabled"
                                   switch
                                   @change="toggleEnabled(feed_type)" />
                </td>
                <td v-if="(!used_feeds || !used_feeds.length) || getUsedCount(feed_type.id) === 0">
                  <a href="javascript:;" class="btn btn-ss-danger btn-sm" @click="deleteFeed(feed_type.id)"><i class="la la-trash" />Delete</a>
                </td>
                <td v-else>
                  In Use.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--end::Portlet-->
  </div>
</template>

<script>
import ConfirmModal from "VueModals/ConfirmModal";
import { BFormCheckbox } from "bootstrap-vue";

export default {
  components: {
    ConfirmModal,
    BFormCheckbox,
  },
  data: () => ({
    feed_types: [],
    used_feeds: [],
    new_feed_type: {
      label: null,
      format: null,
      extension: "xml",
      enabled: true,
    },
  }),

  mounted() {
    this.getFeedTypes();
    this.getFeedsCount();

    EventBus.$on("modal-complete", (ev) => {
      if (ev.name === `add-feed-type-modal`) {
        this.createNewFeedType();
      }
    });
  },
  methods: {
    async getFeedTypes() {
      try {
        const response = await axios.get("/api/v1/feeds/types?admin=true");
        this.feed_types = response.data.data;
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    async getFeedsCount() {
      try {
        const response = await axios.get("/api/v1/admin/feeds/types/used-feeds");
        this.used_feeds = response.data.data.feeds;
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    async toggleEnabled(feed_type) {
      try {
        const response = await axios.patch(`/api/v1/admin/feeds/types/${feed_type.id}`, {
          enabled: !feed_type.enabled,
        });

        if (response.data.data) {
          feed_type = response.data.data;
          toastr.success(`Feed Type ${feed_type.label} saved.`);
        }
      } catch (error) {
        // revert toggle on error
        feed_type.enabled = !feed_type.enabled;
        window.handleAxiosError(error);
      }
    },
    getUsedCount(feed_id) {
      const used_feed = _.find(this.used_feeds, feed => feed.id === feed_id);

      if (used_feed && used_feed.feeds.length) {
        return used_feed.feeds.length;
      }

      return 0;
    },
    async deleteFeed(feed_type_id) {
      try {
        const response = await axios.delete(`/api/v1/admin/feeds/types/${feed_type_id}`);

        if (response.data && response.data.success) {
          this.feed_types = _.filter(this.feed_types, feed_type => feed_type.id !== feed_type_id);
          toastr.success("Deleted");
        } else {
          toastr.error("Unable to delete Feed Type");
        }
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    async createNewFeedType() {
      try {
        if (!this.new_feed_type.label
          || !this.new_feed_type.format
          || !this.new_feed_type.extension
        ) {
          toastr.error("All fields are required");
          return false;
        }

        const response = await axios.post(`/api/v1/admin/feeds/types`, {
          label: this.new_feed_type.label,
          format: this.new_feed_type.format,
          extension: this.new_feed_type.extension,
          enabled: this.new_feed_type.enabled,
        });

        if (response.data.success) {
          toastr.success("Created New Feed Type");
          this.feed_types.push(response.data.data.feed_type);
          this.new_feed_type.label = null;
          this.new_feed_type.format = null;
          this.new_feed_type.extension = "xml";
        }
      } catch (error) {
        console.error(error);
        toastr.error(
          "Format does not exist or it is already added to the database!",
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .table.feeds-table {
    tr, th, td {
      vertical-align: middle !important;
    }
  }
</style>
